var exports = {
  "kL": "x93eb46d8--aa8b9d--container",
  "nf": "x93eb46d8--aa8b9d--link",
  "wm": "x93eb46d8--aa8b9d--logo",
  "Qs": "x93eb46d8--aa8b9d--content",
  "DD": "x93eb46d8--aa8b9d--title",
  "pq": "x93eb46d8--aa8b9d--info",
  "pG": "x93eb46d8--aa8b9d--caption",
};

module.exports = exports;
